<template>
  <section class="c-section c-section--recovery-password py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-7">
          <transition name="fade" mode="out-in" :duration="250">
            <section v-if="step === 1" key="send">
              <div class="bg-white br--medium p-4 py-5">
                <h1 class="mb-2 text-center darks fs-21 w-bold">
                  ¿Olvidaste tu Contraseña?
                </h1>
                <p class="mb-4 text-center">
                  Déjanos tu correo de registro, ¡nos comunicaremos contigo!
                </p>

                <div
                  v-if="alert"
                  class="c-card-alert p-3 mb-4 text-center"
                  :class="`c-card-alert--${alert.type}`"
                >
                  {{alert.message}}
                </div>

                <form
                  class="c-form c-form--ghost"
                  @submit.prevent="sendInstructions()"
                >
                  <div class="row mb-4">
                    <div
                      class="c-form-group col-12 col-lg-12"
                      :class="{'c-form-group--error': $v.email.$error}"
                    >
                      <input
                        type="text"
                        class="c-form__input w-100"
                        placeholder="Correo electrónico"
                        v-model.trim="$v.email.$model"
                      />

                      <span
                        class="c-form__error"
                        v-if="!$v.email.required"
                      >
                        El correo esta vacío
                      </span>
                      <span
                        class="c-form__error"
                        v-else-if="!$v.email.alpha"
                      >
                        El correo es incorrecto
                      </span>
                    </div>
                  </div>

                  <button
                    type="submit"
                    class="c-button c-button--primary w-100"
                    :class="{'loading': isLoading}"
                    :disabled="isLoading"
                  >
                    Enviar instrucciones
                    <img
                      class="c-button__spinner"
                      src="@/assets/images/animations/spinner-white.png"
                    />
                  </button>
                </form>
              </div>
            </section>
            <section v-else key="message">
              <div class="bg-white br--medium p-4 py-5">
                <div class="c-sent-mail text-center">
                  <figure class="c-sent-mail__image mb-4">
                    <img
                      class="w-100 h-100 of--contain"
                      src="@/assets/images/arcux/recovery/email.svg"
                    />
                  </figure>
                  <h2 class="darks fs-21 w-bold">¡Correo enviado!</h2>
                  <p class="black mb-5">
                    Acabamos de enviarte un email a
                    <span class="w-bold darks">
                      {{email}}
                    </span>
                    con las instrucciones.
                  </p>
                  <p class="d-flex justify-content-center mb-0">
                    <router-link
                      to="/ingresar"
                      class="c-button c-button--primary"
                    >
                      Iniciar sesión
                    </router-link>
                  </p>
                </div>
              </div>
            </section>
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  required,
  helpers,
} from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      arcux: {
        ...window.arcux,
      },

      step: 1,
      email: '',

      isLoading: false,

      alert: null,
    };
  },
  validations: {
    email: {
      required,
      alpha: helpers.regex('alpha', /.+@.+\..+/),
    },
  },
  methods: {
    sendInstructions() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isLoading = true;

        const url = `${this.arcux.site}/wp/wp-admin/admin-ajax.php`;

        const formData = new FormData();

        formData.append('action', 'formSendEmail');
        formData.append('email', this.email);

        fetch(url, {
          method: 'POST',
          body: formData,
        })
          .then((res) => {
            if (res.status === 200 || res.status < 300) {
              return res.json();
            }

            return res.text().then((text) => { throw new Error(text); });
          })
          .then((data) => {
            if (!data.success) {
              throw data;
            }

            this.step = 2;
          })
          .catch(this.handleError);
      }
    },

    handleError(error) {
      let errorMessage = '';

      try {
        errorMessage = JSON.parse(error.message)?.message;
      } catch (err) {
        errorMessage = error.message;
      }

      this.alert = {
        type: 'error',
        message: errorMessage,
      };

      this.isLoading = false;

      setTimeout(() => {
        this.alert = null;
      }, 5000);
    },
  },
};
</script>
